import { BusinessCardStack } from './business-card-stack';
import type { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { DougArBusinessCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/business-cards-2x3/doug-ar-business-card-stack-background/doug-ar-business-card-stack-background.component';
import { DougArBusinessCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/business-cards-2x3/doug-ar-business-card-stack-content/doug-ar-business-card-stack-content.component';

export class DougArBusinessCardStack extends BusinessCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    return DougArBusinessCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return DougArBusinessCardStackContentComponent;
  }

  nonPerforatedBleedBorderInInches(): number {
    return 0;
  }

  getCardHeightInInches(): number {
    return 2;
  }
}
